import { render, staticRenderFns } from "./BasicModal.vue?vue&type=template&id=61e27fbb&scoped=true&"
import script from "./BasicModal.vue?vue&type=script&lang=js&"
export * from "./BasicModal.vue?vue&type=script&lang=js&"
import style0 from "./BasicModal.vue?vue&type=style&index=0&id=61e27fbb&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e27fbb",
  null
  
)

export default component.exports